import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { List, Spin, Dropdown } from "antd";
import { __ } from "../../utils";
import { deleteJobs, retryJobs, skipJobs } from "../../queue";
const ErrorModalListItem = (param)=>{
    let { item: { actions, type, label, description, failedJobs } } = param;
    const [busy, setBusy] = useState(false);
    const handleDelete = useCallback(async ()=>{
        setBusy(true);
        try {
            await deleteJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const handleRetry = useCallback(async ()=>{
        setBusy(true);
        try {
            await retryJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const handleSkip = useCallback(async ()=>{
        setBusy(true);
        try {
            await skipJobs({
                type
            });
        } finally{
            setBusy(false);
        }
    }, [
        type
    ]);
    const useActionText = useCallback((action, defaultText)=>{
        var _actions_filter_;
        return ((_actions_filter_ = actions.filter((param)=>{
            let { action: a } = param;
            return action === a;
        })[0]) == null ? void 0 : _actions_filter_.linkText) || defaultText;
    }, [
        actions
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy,
        children: /*#__PURE__*/ _jsx(List.Item, {
            style: {
                paddingLeft: 0,
                paddingRight: 0
            },
            actions: [
                /*#__PURE__*/ _jsx(Dropdown.Button, {
                    onClick: handleRetry,
                    menu: {
                        items: [
                            {
                                key: "skip",
                                label: useActionText("skip", __("Skip failed jobs")),
                                onClick: handleSkip
                            },
                            ...actions.map((param)=>{
                                let { action, url, linkText, target = "_blank" } = param;
                                return !action && {
                                    key: url,
                                    onClick: ()=>window.open(url, target),
                                    label: linkText
                                };
                            }),
                            {
                                key: "delete",
                                danger: true,
                                label: useActionText("delete", __("Cancel process")),
                                onClick: handleDelete
                            }
                        ]
                    },
                    children: useActionText("retry", __("Retry"))
                }, "test")
            ],
            children: /*#__PURE__*/ _jsx(List.Item.Meta, {
                title: label,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: description
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ _jsx("strong", {
                                children: __("Error message:")
                            })
                        }),
                        failedJobs.slice(0, 1).map((job)=>{
                            const { id, exception: { errors } } = job;
                            return /*#__PURE__*/ _jsx("div", {
                                "data-job": id,
                                onClick: ()=>console.log(job),
                                children: Object.keys(errors).map((code)=>/*#__PURE__*/ _jsx("div", {
                                        "data-code": code,
                                        dangerouslySetInnerHTML: {
                                            __html: errors[code].join("<br />")
                                        }
                                    }, code))
                            }, id);
                        })
                    ]
                })
            })
        })
    });
};
export { ErrorModalListItem };
